// src/components/molecules/auth/remember-me-toggle.tsx
"use client";

import { cn } from "@/lib/utils";
import { AuthToggleSwitch } from "@/components/atoms/auth/auth-toggle-switch";

type RememberMeToggleProps = {
  checked: boolean;
  onCheckedChange: (value: boolean) => void;
  disabled?: boolean;
  id?: string;
  className?: string;
};

export function RememberMeToggle({
  checked,
  onCheckedChange,
  disabled,
  id = "remember-me",
  className,
}: RememberMeToggleProps) {
  const labelId = `${id}-label`;
  return (
    <div className={cn("flex min-h-11 items-center justify-end gap-3", className)}>
      <span id={labelId} className="text-sm font-semibold text-brand-ink">
        Remember me
      </span>
      <AuthToggleSwitch
        id={id}
        checked={checked}
        onCheckedChange={onCheckedChange}
        disabled={disabled}
        aria-labelledby={labelId}
      />
    </div>
  );
}
